module.exports = __webpack_public_path__ + "static/media/Kaitlyn.ef2b6ec3.jpg";